import moment from "moment";
import { TOption } from "../Models/common";


// Constant COLORS
export const SIDEBAR_BACKGROUND_COLOR = "rgba(228, 204, 162, 0.5)";
export const GMS_STEPS = {
  INBOUND: "Inbound",
  // PVC_TO_PLANT: "Transfer Order From PVC To Plant",
  SUMMARY: "Summary",
};

export const TRANSACTION_STEPS = {
  INBOUND: "Inbound",
  PVC_TO_PLANT: "Transfer Order From PVC To Plant",
  PLANT_TO_PVC: "Transfer Order From Plant To PVC",
  PHYSICAL_ORDER: "Physical Order",
  DELIVERY: "Delivery",
  BILLING: "Billing",
  SUMMARY: "Summary",
};

export const JOB_WORK_STEPS = {
  INBOUND: "Inbound",
  PHYSICAL_ORDER: "Physical Order",
  PVC_TO_PLANT: "Transfer Order From PVC To Plant",
  CONFIRM_PHYSICAL_ORDER: "Confirm Physical Order",
  BILLING: "Billing",
  DELIVERY: "Delivery",
  SUMMARY: "Summary",
};

export const BUY_SELL_STEPS = {
  INBOUND: "Inbound",
  PHYSICAL_ORDER: "Physical Order",
  BILLING: "Billing",
  // DELIVERY: "Delivery",
  SUMMARY: "Summary",
};
export const MINTED_SALES = {
  PHYSICAL_ORDER: "Physical Order",
  BILLING: "Billing",
  SUMMARY: "Summary",
};

export const BUY_BACK_STEPS = {
  INBOUND: "Inbound",
  BILLING: "Billing",
  SUMMARY: "Summary",
};
export const PURITY_TESTING_STEPS = {
  INBOUND: "Inbound",
  BILLING: "Billing",
  SUMMARY: "Summary",
};

export const breakpoints = {
  mobile: 768,
  tab: 1024,
};

export const PATHS = {
  DASHBOARD: "/",
  CREATE_TRANSACTION: "/CreateTransaction",
  LOGIN: "/login",
  GMS: "/gms",
  BUY_BACK: "/buyback",
  BUY_SELL: "/buysell",
  JOB_WORK: "/jobwork",
  PURITY_TESTING: "/puritytesting",
  MINTED_SALES: "/mintedsales",
  PVC_TRANSACTIONS: "/pvcTransaction",
  CUSTOMERS: "/customers",
  CUSTOMER_SETUP: "/customerSetup",
  BILLING_BLOTTER: "/billingBlotter",
  PAYMENT_BLOTTER: "/paymentBlotter",
  DELIVERY_BLOTTER: "/deliveryBlotter",
  INBOUND_BLOTTER: "/inboundBlotter",
  PHYSICAL_BLOTTER: "/physicalBlotter",
  TRADE_BLOTTER: "/tradeBlotter",
  TRANSFERS_BLOTTER: "/transfersBlotter",
  INVENTORY: "/inventory",
  INVENTORY_ADJUSTMENT: "/inventoryAdjustment",
  INVENTORY_REQUEST: "/inventoryRequest",
  INVENTORY_MANAGEMENT: "/inventoryManagement",
  TRANSFER_ORDER: "/transferOrder",
  USER_MASTER: "/userMaster",
  REPORTS: "/reports",
  PVCREPORTS : '/pvcReports',
  TRANSACTIONALREPORT : "/transactionalReport",
  DOCUMENTREPORT : "/documentReport",
  SALESREPORT : "/salesReport",
  STOCKAGEINGREPORT : "/stockAgeingReport",
  PAYMANTSREPORT : "/paymentsReport",
  STOCKORDERSREPORT : "/stockOrdersReport",
  INVENTORYONHANDREPORT : "/inventoryOnHandReport",
  STOCKINREPORT : "/stockInReport",
  STOCKOUTREPORT : "/stockOutReport",
  STOCKREPORT : "/stockReport",
  SKYCREPORT : "/skycReport",
  EMPLOYEES: '/employees',
  REDEEM_AT_PVC : '/redeemAtPvc',
  REDEEM_AT_PVC_TRANSACTION : '/redeemAtPvcTransaction'






};
export const pvcStockOrderDetails = [
  // {
  //     id: "skuId",
  //     label: 'SKU ID',
  // },
  {
      id: "destination",
      label: 'Location Name',
  },
  {
      id: "shipper",
      label: 'Shipper Name',
  },
  {
      id: "productName",
      label: 'Product Name',
  },
  {
      id: "description",
      label: 'Product description',
  },
  {
      id: "totalRate",
      label: 'Total Rate (INR)',
  },
  {
      id: "metal",
      label: 'Metal Type',
  },
  {
      id: "purity",
      label: 'Purity (ppt)',
  },
  {
      id: "quantity",
      label: 'Quantity (pcs)',
  },
  {
      id: "weight",
      label: 'Total Net Wt (gms)',
  },
  {
      id: "fineWeight",
      label: 'Total Fine Wt (gms)'
  },
  {
      id: "dimensions",
      label: 'Dimension',
  },
  {
      id: "shape",
      label: 'Shape',
  },
  {
      id: "acknowledgementStatus",
      label: 'Acknowledgement Status',
  },
  {
      id: "mtsTransferType",
      label: 'Transfer Type',
  },
  {
      id: "serialNumber",
      label: 'Serial Number',
  },
  {
      id: "acknowledgedDate",
      label: 'Acknowledged Date',
  },
  {
      id: "createdAt",
      label: 'Created At',
  },
  {
      id: "documentNumber",
      label: 'Document No',
  },
  {
      id: "date",
      label: 'Date',
  },
  {
      id: "createdBy",
      label: 'Created By',
  },
  {
      id: "logisticName",
      label: 'Logistic Name',
  },
  {
        id: "metalOutTime",
        label: 'Metal Out Time',
  },
  {
        id: "metalOutUpdatedTime",
        label: 'Metal Out Updated Time',
  },
]
export const inventoryOnHandData = [
  {
      id: "itemNo",
      label: 'Item No.',
  },
  {
      id: "itemDescription",
      label: 'Item Description',
  },
  {
      id: "metal",
      label: 'Metal',
  },
  {
      id: "inventoryType",
      label: 'Inventory Type',
  },
  {
      id: "fineWeight",
      label: 'Fine Weight',
  },
  {
      id: "inventoryLocation",
      label: 'Inventory Location',
  },
  {
      id: "qtyOnHand",
      label: 'Qty On Hand',
  },
  {
      id: "qtyAvailableForSale",
      label: 'Qty Available For Sale',
  },
  {
      id: "qtyAvailableForTransfer",
      label: 'Qty Available For Transfer',
  },
  {
      id: "qtyInTransitInbound",
      label: 'Qty In-transit Inbound',
  },
  {
      id: "qtyInTransitOutbound",
      label: 'Qty In-transit Outbound',
  },
  {
      id: "fineMetalBaseUnit",
      label: 'Fine Metal Base Unit',
  },
  {
      id: "netMetalBaseUnit",
      label: 'Net Metal Base Unit',
  }
]
export const pvcStockInDetails = [
  {
      id: "srNo",
      label: 'Sr No.',
  },
  {
      id: "exciseNo",
      label: 'Excise No.',
  },
  {
      id: "stockTransferNo",
      label: 'Stock Transfer No.',
  },
  {
      id: "stockTransferDate",
      label: 'Stock Transfer Date',
  },
  {
      id: "destinationLcoation",
      label: 'Destination Lcoation',
  },
  {
      id: "metal",
      label: 'Metal',
  },
  {
      id: "purity",
      label: 'Purity',
  },
  {
      id: "denomination",
      label: 'Denomination',
  },
  {
      id: "productDesign",
      label: 'Product Design',
  },
  {
      id: "totalNetWeight",
      label: 'Total Net Weight',
  },
  {
      id: "transferredQty",
      label: 'Transferred Qty',
  },
  {
      id: "balanceQuantity",
      label: 'Balance Quantity',
  },
  {
      id: "agingDays",
      label: 'Aging Days',
  },
  {
      id: "serialNumbers",
      label: 'Serial No.',
  },
]
export const pvcStockOutOrderDetails = [
    // {
    //     id: "skuId",
    //     label: 'SKU ID',
    // },
    {
        id: "destination",
        label: 'Customer Name Location',
    },
    {
        id: "customerGstIn",
        label: 'Customer Billing GST No',
    },
    {
        id: "customerDeliveryLocation",
        label: 'Customer Delivery Location',
    },
    {
        id: "customerDeliveyCity",
        label: 'Customer Delivery City',
    },
    {
        id: "customerDeliveryState",
        label: 'Customer Delivery State',
    },
    {
        id: "shipper",
        label: 'Supplier Location',
    },
    {
        id: "supplierDeliveyCity",
        label: 'Supplier City',
    },
    {
        id: "supplierDeliveryState",
        label: 'Supplier State',
    },
    {
        id: "supplierGstIn",
        label: 'Supplier GST No',
    },
    {
        id: "hsnCode",
        label: 'HSN Code',
    },
    {
        id: "productName",
        label: 'Product Name',
    },
    // {
    //     id: "description",
    //     label: 'Product description',
    // },
    {
        id: "totalRate",
        label: 'Total Invoice Value',
    },
    {
        id: "metal",
        label: 'Metal Type',
    },
    {
        id: "purity",
        label: 'Purity (ppt)',
    },
    {
        id: "quantity",
        label: 'Quantity (pcs)',
    },
    {
        id: "weight",
        label: 'Total Net Wt (gms)',
    },
    {
        id: "fineWeight",
        label: 'Total Fine Wt (gms)'
    },
    {
        id: "valueOfMetal",
        label: 'Value Of Metal'
    },
    {
        id: "taxableValue",
        label: 'Taxable Value '
    },
    {
        id: "CGSTPercentage",
        label: 'CGST Percentage'
    },
    {
        id: "CGSTValue",
        label: 'CGST Value'
    },
    {
        id: "SGSTPercentage",
        label: 'SGST Percentage'
    },
    {
        id: "SGSTValue",
        label: 'SGST Value'
    },
    {
        id: "IGSTPercentage",
        label: 'IGST Percentage'
    },
    {
        id: "IGSTValue",
        label: 'IGST Value'
    },
    // {
    //     id: "dimensions",
    //     label: 'Dimension',
    // },
    // {
    //     id: "shape",
    //     label: 'Shape',
    // },
    {
        id: "acknowledgementStatus",
        label: 'Acknowledgement Status',
    },
    {
        id: "mtsTransferType",
        label: 'Transfer Type',
    },
    {
        id: "serialNumber",
        label: 'Serial Number',
    },
    {
        id: "acknowledgedDate",
        label: 'Acknowledged Date',
    },
    {
        id: "createdAt",
        label: 'Created At',
    },
    {
        id: "documentNumber",
        label: 'Document No',
    },
    {
        id: "date",
        label: 'Date',
    },
    {
        id: "createdBy",
        label: 'Created By',
    },
    {
        id: "logisticName",
        label: 'Logistic Name',
    },
    {
        id: "metalOutTime",
        label: 'Metal Out Time',
    },
    {
        id: "metalOutUpdatedTime",
        label: 'Metal Out Updated Time',
    },
]

export const salesReportHeader = [
  {
      id: "srNo",
      label: 'SR No.',
  },
  {
      id: "gtNumber",
      label: 'GT Number',
  },
  {
      id: "orderID",
      label: 'Order ID',
  },
  {
      id: "invoiceNo",
      label: 'Invoice No.',
  },
  {
    id: "monthName",
    label: 'Month Name',
  },
  {
      id: "invoiceDate",
      label: 'Invoice Date',
  },
 
  {
      id: "fromCustomer",
      label: 'From Customer',
  },
  {
      id: "sourceDeliveryLocation",
      label: 'From Location',
  },
  {
      id: "customer",
      label: 'Customer Name',
  },
  {
      id: "category",
      label: 'Customer Category',
  },
  {
      id: "createdBy", 
      label: 'Created By',
  },
  {
      id: "DeliveryLocation",
      label: 'Delivery Location',
  },
  {
      id: "BillingLocation",
      label: 'Billing Location',
  },
  {
      id: "deliveryType",
      label: 'delivery Type',
  },
  {
      id: "deliveryDate",
      label: 'Delivery Date',
  },
  {
      id: "InvoiceType",
      label: 'Invoice Type',
  },
  {
    id: "salesType",
    label: "Sales Type"
},
  {
      id: "InvoiceCategory",
      label: 'Invoice Category',
  },
  {
      id: "referenceName",
      label: 'Reference Name',
  },
  {
      id: "referenceNumber",
      label: 'reference Number',
  },
    // {
    //     id: "totalNetWeightGm",
    //     label: 'Total Net Weight Gm',
    // },
    // {
    //     id: "totalFineWeight",
    //     label: 'Total Fine Weight Gm',
    // },
    {
        id: "totalGoldNetWeight",
        label: 'Total Gold Net Weight Gm',
    },
    {
        id: "totalSilverNetWeight",
        label: 'Total Silver Net Weight Gm',
    },
    {
        id: "totalGoldFineWeight",
        label: 'Total Gold Fine Weight Gm',
    },
    {
        id: "totalSilverFineWeight",
        label: 'Total Silver Fine Weight Gm',
    },
  {
      id: "grossRate",
      label: 'Gross Rate',
  },
  {
      id: "tcsPercentage",
      label: 'TCS Percentage',
  },
  {
    id: "totalTax",
    label: "Total Tax"
  },
  {
      id: "tcsAmount",
      label: 'TCS Amount',
  },
  {
      id: "totalCGSTValue",
      label: 'Total CGST Value',
  },
  {
      id: "totalSGSTValue",
      label: 'Total SGST Value',
  },
  {
      id: "totalIGSTValue",
      label: 'Total IGST Value',
  },
  {
      id: "cardCharges",
      label: 'Card Charges',
  },
  {
      id: "discount",
      label: 'Discount',
  },
  {
      id: "totalDiscountValue",
      label: 'Total Discount Value',
  },
  {
      id: "KFCPercentage",
      label: 'KFC Percentage',
  },
  {
      id: "KFCAmount",
      label: 'KFC Amount',
  },
  {
      id: "adjustment",
      label: 'Adjustment',
  },
  {
      id: "grandTotal",
      label: 'Grand Total',
  },
  {
      id: "metal",
      label: 'Metal Type',
  },
  {
      id: "productName",
      label: 'product Name',
  },
  {
      id: "productDescription",
      label: 'Product Description',
  },
  {
      id: "purity",
      label: 'Purity',
  },
  {
      id: "netWeight",
      label: 'Net Weight',
  },
  {
      id: "fineWeight",
      label: 'Fine Weight',
  },
  {
      id: "weight",
      label: 'Weight',
  },
  // {
  //     id: "purity",
  //     label: 'Purity',
  // },
  {
      id: "doQuantity",
      label: 'Do Quantity',
  },
  {
      id: "perPieceRate",
      label: 'Per Piece Rate',
  },
  {
      id: "discountValue",
      label: 'Discount Value',
  },
  {
      id: "CGSTPercentage",
      label: 'CGST Percentage',
  },
  {
      id: "CGSTValue",
      label: 'CGST Value',
  },
  {
      id: "SGSTPercentage",
      label: 'SGST Percentage',
  },
  {
      id: "SGSTValue",
      label: 'SGST Value',
  },
  {
      id: "IGSTPercentage",
      label: 'IGST Percentage',
  },
  {
      id: "IGSTValue",
      label: 'IGST Value',
  },
  {
      id: "valueOfMetal",
      label: 'value Of Metal',
  },
  {
      id: "createdOn",
      label: 'created On',
  },
  {
      id: "remarks",
      label: 'Remarks',
  },
  {
      id: "status",
      label: 'Status',
  },
  {
      id: "cancelledOn",
      label: 'Cancelled On',
  },
  {
      id: "cancelReason",
      label: 'Cancel Reason',
  },
  {
    id: "productHsnCode",
    label: "HSN Code"
},
{
    id: "customerPan",
    label: "Customer Pan"
},
{
    id: "customerTan",
    label: "Customer TAN"
},
{
    id: "customerMobile",
    label: "Customer Mobile"
},
{
    id: "customerGstin",
    label: "Customer Gstin"
},
{
    id: "shippingCityName",
    label: "Shipping City Name"
},
{
    id: "shippingState",
    label: "Shipping State"
},
{
    id: "shippingStateCode",
    label: "Shipping State Code"
},
{
    id: "billingCityName",
    label: "Billing City Name"
},
{
    id: "billingState",
    label: "Billing State"
},
{
    id: "billingStateCode",
    label: "Billing State Code"
},
{
    id: "billingGstin",
    label: "Billing Gstin"
},
{
    id: "suppliersCity",
    label: "Suppliers City"
},
{
    id: "suppliersState",
    label: "Suppliers State"
},
{
    id: "suppliersStateCode",
    label: "Suppliers State Code"
},
{
    id: "suppliersGstin",
    label: "suppliers Gstin"
}
 

  
]
export const shortKyctransactionDetails = [
  {
      id: "srno",
      label: 'Sr No.',
  },
  {
      id: "customerName",
      label: 'Customer Name',
  },
  {
      id: "customerPanNumber",
      label: 'Customer PAN No.',
  },
  {
      id: "customerCategory",
      label: 'Customer Category',
  },
  {
      id: "createdOn",
      label: 'Created On',
  },
  {
      id: "transactionCount",
      label: 'Transaction Count',
  },
  {
      id: "totalGoldFineWeight",
      label: 'Total Gold Weight',
  },
  {
      id: "totalSilverFineWeight",
      label: 'Total Silver Weight',
  },
  {
      id: "remarks",
      label: 'Remarks',
  },
 
]


// export const STATES = [
//   { value: "JAMMU KASHMIR", label: "JAMMU KASHMIR", code: "1" },
//   { value: "HIMACHAL PRADESH", label: "HIMACHAL PRADESH", code: "2" },
//   { value: "PUNJAB", label: "PUNJAB", code: "3" },
//   { value: "CHANDIGARH", label: "CHANDIGARH", code: "4" },
//   { value: "UTTARAKHAND", label: "UTTARAKHAND", code: "5" },
//   { value: "HARYANA", label: "HARYANA", code: "6" },
//   { value: "DELHI", label: "DELHI", code: "7" },
//   { value: "RAJASTHAN", label: "RAJASTHAN", code: "8" },
//   { value: "UTTAR PRADESH", label: "UTTAR PRADESH", code: "9" },
//   { value: "BIHAR", label: "BIHAR", code: "10" },
//   { value: "SIKKIM", label: "SIKKIM", code: "11" },
//   { value: "ARUNACHAL PRADESH", label: "ARUNACHAL PRADESH", code: "12" },
//   { value: "NAGALAND", label: "NAGALAND", code: "13" },
//   { value: "MANIPUR", label: "MANIPUR", code: "14" },
//   { value: "MIZORAM", label: "MIZORAM", code: "15" },
//   { value: "TRIPURA", label: "TRIPURA", code: "16" },
//   { value: "MEGHALAYA", label: "MEGHALAYA", code: "17" },
//   { value: "ASSAM", label: "ASSAM", code: "18" },
//   { value: "WEST BENGAL", label: "WEST BENGAL", code: "19" },
//   { value: "JHARKHAND", label: "JHARKHAND", code: "20" },
//   { value: "ODISHA", label: "ODISHA", code: "21" },
//   { value: "CHHATTISGARH", label: "CHHATTISGARH", code: "22" },
//   { value: "MADHYA PRADESH", label: "MADHYA PRADESH", code: "23" },
//   { value: "GUJARAT", label: "GUJARAT", code: "24" },
//   { value: "DAMAN AND DIU", label: "DAMAN AND DIU", code: "25" },
//   {
//     value: "DADRA & NAGAR HAVELI",
//     label: "DADRA & NAGAR HAVELI",
//     code: "26",
//   },
//   { value: "MAHARASHTRA", label: "MAHARASHTRA", code: "27" },
//   { value: "KARNATAKA", label: "KARNATAKA", code: "29" },
//   { value: "GOA", label: "GOA", code: "30" },
//   { value: "LAKSHADWEEP", label: "LAKSHADWEEP", code: "31" },
//   { value: "KERALA", label: "KERALA", code: "32" },
//   { value: "TAMILNADU", label: "TAMILNADU", code: "33" },
//   { value: "PUDUCHERRY", label: "PUDUCHERRY", code: "34" },
//   {
//     value: "ANDAMAN & NICOBAR ISLANDS",
//     label: "ANDAMAN & NICOBAR ISLANDS",
//     code: "35",
//   },
//   { value: "TELANGANA", label: "TELANGANA", code: "36" },
//   { value: "ANDHRA PRADESH", label: "ANDHRA PRADESH", code: "37" },
//   { value: "Other Country", label: "Other Country", code: "96" },
// { value: "Other Territory", label: "Other Territory", code: "97" },



export const STATES_CODES_CLIENT = [
  { value: "JAMMU KASHMIR", label: "JAMMU KASHMIR", code: "1" },
  { value: "HIMACHAL PRADESH", label: "HIMACHAL PRADESH", code: "2" },
  { value: "PUNJAB", label: "PUNJAB", code: "3" },
  { value: "CHANDIGARH", label: "CHANDIGARH", code: "4" },
  { value: "UTTARAKHAND", label: "UTTARAKHAND", code: "5" },
  { value: "HARYANA", label: "HARYANA", code: "6" },
  { value: "DELHI", label: "DELHI", code: "7" },
  { value: "RAJASTHAN", label: "RAJASTHAN", code: "8" },
  { value: "UTTAR PRADESH", label: "UTTAR PRADESH", code: "9" },
  { value: "BIHAR", label: "BIHAR", code: "10" },
  { value: "SIKKIM", label: "SIKKIM", code: "11" },
  { value: "ARUNACHAL PRADESH", label: "ARUNACHAL PRADESH", code: "12" },
  { value: "NAGALAND", label: "NAGALAND", code: "13" },
  { value: "MANIPUR", label: "MANIPUR", code: "14" },
  { value: "MIZORAM", label: "MIZORAM", code: "15" },
  { value: "TRIPURA", label: "TRIPURA", code: "16" },
  { value: "MEGHALAYA", label: "MEGHALAYA", code: "17" },
  { value: "ASSAM", label: "ASSAM", code: "18" },
  { value: "WEST BENGAL", label: "WEST BENGAL", code: "19" },
  { value: "JHARKHAND", label: "JHARKHAND", code: "20" },
  { value: "ODISHA", label: "ODISHA", code: "21" },
  { value: "CHHATTISGARH", label: "CHHATTISGARH", code: "22" },
  { value: "MADHYA PRADESH", label: "MADHYA PRADESH", code: "23" },
  { value: "GUJARAT", label: "GUJARAT", code: "24" },
  { value: "DAMAN AND DIU", label: "DAMAN AND DIU", code: "25" },
  {
    value: "DADRA & NAGAR HAVELI",
    label: "DADRA & NAGAR HAVELI",
    code: "26",
  },
  { value: "MAHARASHTRA", label: "MAHARASHTRA", code: "27" },
  { value: "KARNATAKA", label: "KARNATAKA", code: "29" },
  { value: "GOA", label: "GOA", code: "30" },
  { value: "LAKSHADWEEP", label: "LAKSHADWEEP", code: "31" },
  { value: "KERALA", label: "KERALA", code: "32" },
  { value: "TAMILNADU", label: "TAMILNADU", code: "33" },
  { value: "PUDUCHERRY", label: "PUDUCHERRY", code: "34" },
  {
    value: "ANDAMAN & NICOBAR ISLANDS",
    label: "ANDAMAN & NICOBAR ISLANDS",
    code: "35",
  },
  { value: "TELANGANA", label: "TELANGANA", code: "36" },
  { value: "ANDHRA PRADESH", label: "ANDHRA PRADESH", code: "37" },
  { value: "Other Country", label: "Other Country", code: "96" },
{ value: "Other Territory", label: "Other Territory", code: "97" },
]




export const STATES = [
  { value: "Other Territory", label: "Other Territory", code: "97" }

];
export const STATE_CODES = [
  { value: "AP", label: "AP" },
  { value: "AR", label: "AR" },
  { value: "AS", label: "AS" },
  { value: "BR", label: "BR" },
  { value: "CT", label: "CT" },
  { value: "GA", label: "GA" },
  { value: "GJ", label: "GJ" },
  { value: "HR", label: "HR" },
  { value: "HP", label: "HP" },
  { value: "JK", label: "JK" },
  { value: "JH", label: "JH" },
  { value: "KA", label: "KA" },
  { value: "KL", label: "KL" },
  { value: "MP", label: "MP" },
  { value: "MH", label: "MH" },
  { value: "MN", label: "MN" },
  { value: "ML", label: "ML" },
  { value: "MZ", label: "MZ" },
  { value: "NL", label: "NL" },
  { value: "OR", label: "OR" },
  { value: "PB", label: "PB" },
  { value: "RJ", label: "RJ" },
  { value: "SK", label: "SK" },
  { value: "TN", label: "TN" },
  { value: "TS", label: "TS" },
  { value: "TR", label: "TR" },
  { value: "UP", label: "UP" },
  { value: "UK", label: "UK" },
  { value: "WB", label: "WB" },
  { value: "AN", label: "AN" },
  { value: "CH", label: "CH" },
  { value: "DN", label: "DN" },
  { value: "LD", label: "LD" },
  { value: "DL", label: "DL" },
  { value: "PY", label: "PY" },
  { value: "LA", label: "LA" },
];

// export const STATE_CODES = [
//     { value: 'AP', label: 'ANDHRA PRADESH' },
//     { value: 'AR', label: 'ARUNACHAL PRADESH' },
//     { value: 'AS', label: 'ASSAM' },
//     { value: 'BR', label: 'BIHAR' },
//     { value: 'CT', label: 'CHHATTISGARH' },
//     { value: 'GA', label: 'GOA' },
//     { value: 'GJ', label: 'GUJARAT' },
//     { value: 'HR', label: 'HARYANA' },
//     { value: 'HP', label: 'HIMACHAL PRADESH' },
//     { value: 'JK', label: 'JAMMU KASHMIR' },
//     { value: 'JH', label: 'JHARKHAND' },
//     { value: 'KA', label: 'KARNATAKA' },
//     { value: 'KL', label: 'KERALA' },
//     { value: 'MP', label: 'MADHYA PRADESH' },
//     { value: 'MH', label: 'MAHARASHTRA' },
//     { value: 'MN', label: 'MANIPUR' },
//     { value: 'ML', label: 'MEGHALAYA' },
//     { value: 'MZ', label: 'MIZORAM' },
//     { value: 'NL', label: 'NAGALAND' },
//     { value: 'OR', label: 'ODISHA' },
//     { value: 'PB', label: 'PUNJAB' },
//     { value: 'RJ', label: 'RAJASTHAN' },
//     { value: 'SK', label: 'SIKKIM' },
//     { value: 'TN', label: 'TAMILNADU' },
//     { value: 'TS', label: 'TELANGANA' },
//     { value: 'TR', label: 'TRIPURA' },
//     { value: 'UP', label: 'UTTAR PRADESH' },
//     { value: 'UK', label: 'UTTARAKHAND' },
//     { value: 'WB', label: 'WEST BENGAL' },
//     { value: 'AN', label: 'ANDAMAN & NICOBAR ISLANDS' },
//     { value: 'CH', label: 'CHANDIGARH' },
//     { value: 'DN', label: 'DADRA & NAGAR HAVELI and DAMAN AND DIU' },
//     { value: 'LD', label: 'LAKSHADWEEP' },
//     { value: 'DL', label: 'DELHI' },
//     { value: 'PY', label: 'PUDUCHERRY' },
//     { value: 'LA', label: 'Ladakh' },
//   ];

export const COUNTRIES = [
  { value: "India", label: "India" },
  // { value: "United States", label: "United States" },
  // { value: "Canada", label: "Canada" },
  // { value: "United Kingdom", label: "United Kingdom" },
  // { value: "Australia", label: "Australia" },
  // { value: "Germany", label: "Germany" },
  // { value: "France", label: "France" },
  // { value: "Japan", label: "Japan" },
  // { value: "China", label: "China" },
  // { value: "Brazil", label: "Brazil" },
  // { value: "Russia", label: "Russia" },
  // { value: "South Africa", label: "South Africa" },
  // { value: "Mexico", label: "Mexico" },
  // { value: "Argentina", label: "Argentina" },
  // { value: "New Zealand", label: "New Zealand" },
  // { value: "Singapore", label: "Singapore" },
  // { value: "South Korea", label: "South Korea" },
  // { value: "Netherlands", label: "Netherlands" },
  // { value: "Italy", label: "Italy" },
  // { value: "Spain", label: "Spain" },
  // { value: "Switzerland", label: "Switzerland" },
  // { value: "Sweden", label: "Sweden" },
  // { value: "Norway", label: "Norway" },
  // { value: "Denmark", label: "Denmark" },
  // { value: "Ireland", label: "Ireland" },
  // { value: "Belgium", label: "Belgium" },
  // { value: "Portugal", label: "Portugal" },
  // { value: "Greece", label: "Greece" },
  // { value: "Egypt", label: "Egypt" },
  // { value: "Nigeria", label: "Nigeria" },
];

export const AADHAR = {
  FRONT_SIDE: "FrontSide",
  BACK_SIDE: "BackSide",
};

export const PERMISSIONS = [
  {
    name: "customer",
    label: "Customer",
    privilages: [],
  },
  {
    name: "buyback",
    label: "Buy Back",
    privilages: [],
  },
  {
    name: "buysell",
    label: "Buy Sell",
    privilages: [],
  },
  {
    name: "gms",
    label: "GMS",
    privilages: [],
  },
  {
    name: "jobwork",
    label: "Job Work",
    privilages: [],
  },
  {
    name: "puritytesting",
    label: "Purity Testing",
    privilages: [],
  },
];

export const TRANSACTION_STATUS = {
  INBOUND_INITIATED: "INBOUND_INITIATED",
  PHYSICAL_ORDER_INITIATED: "PHYSICAL_ORDER_INITIATED",
  PAYMENT_INITIATED: "PAYMENT_INITIATED",
  DELIVERY_INITIATED: "DELIVERY_INITIATED",
  COMPLETED: "COMPLETED",
  PVC_TO_PLANT_INITIATED:"PVC_TO_PLANT_INITIATED",
  CONFIRM_PHYSICAL_ORDER:"CONFIRM_PHYSICAL_ORDER",
  CANCELLED: 'CANCELLED',
  PENDING_CANCELLATION: 'PENDING_CANCELLATION',
};

export const REDEEM_AT_PVC_TRANSACTION_STATUS = {
  PICK_UP_AT_PVC : "PICK_UP_AT_PVC",
  COMPLETED: "COMPLETED",
};


export const TRANSACTION_TYPES = {
  BUY_SELL: 'BUY_SELL',
  PURITY_TESTING: 'PURITY_TESTING',
  BUY_BACK:'BUY_BACK',
  MINTED_SALES:'MINTED_SALES',
  GMS:'GMS',
  JOB_WORK:'JOB_WORK',
}
export const CURRENCIES = {
  INR : 'INR'
}

export const WEIGHT_UNITS = {
  GM : 'GM'
}
export const INBOUND_PRODUCT_TYPE = {
  "Recycled Metal Gold": "RECYCLED_METAL_GOLD",
  "Recycled Metal Silver": "RECYCLED_METAL_SILVER",
};

export const LINE_PRODUCT_TYPE = {
  INBOUNDSCRAP: "INBOUNDSCRAP",
  "MMTC-PAMP Product": "MMTC-PAMP Product",
  INBFINENEWJOBWORK: "INBFINENEWJOBWORK",
  DOREBAR: "DOREBAR",
};

export const DataFormat = "DD-MM-YYYY hh:mm a";

// export const SERIAL_NUMBER_REGEX = /^\d+([-]\d+)*([,]\d+([,]\d+)*([-]\d+)*)*$/
export const SERIAL_NUMBER_REGEX = /^\d+(?:[,-]\d+)*[,-]?$/;
export const FLOAT_REGEX = /^(\d+(\.\d*)?|\.\d+)$/;
export const NUMBER_REGEX = /^[0-9]+$/;
export const IFSC_REGEX = /^[A-Z]{4}0[A-Z0-9]{6}$/;
export const TWO_DECIMAL_PLACES_REGEX = /^\d+(\.\d{1,2})?$/;
export const PAN_REGEX = /[A-Z]{5}[0-9]{4}[A-Z]{1}/;
export const AADHAR_REGEX = /^\d{4}\d{4}\d{4}$/;
export const MOBILE_NUMBER_REGEX = /^(?:(?:\+|0{0,2})91(\s*[\-]\s*)?|[0]?)?[6789]\d{9}$/;
export const SIX_MASKED_DIGITS_REGEX = /^\*{6}\d{4}$/;
export const GSTIN_REGEX =  /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/
export const GOLD_VALUE = 6414.24;
export const SILVER_VALUE = 541.42

export const BUYBACK_TYPES = {
  MMTC_PAMP_PRODUCT: "MMTC_PAMP_PRODUCT",
  MELTING: "MELTING",
  NON_MELTING: "NON_MELTING",
};

export const METAL_TYPES = {
  GOLD: "gold",
  SILVER: "silver",
};

export const ORDER_CATEGORY = {
  SELL: "SELL",
  BUY: "BUY",
  GMS: "GMS",
  SERVICE: "SERVICE_ORDER",
};

export const GRAIN_SKU = 'AUYyGRG0.001831'
export const MMTC_PRODUCT_NONMELTED_LIMIT=49  // in gram

export const REQUEST_STATUS ={
  PENDING: 'pending',
  APPROVED: 'approved',
  REJECTED: 'rejected'
}

export const INVENTORY_TYPE = {
  NORMAL_SKU: 1, // 'normal SKU'
  CUT_BAR_LOOSE_ITEMS: 2, //'Cut Bar/Loose Items'
  BUFFING_DUST: 3, //'buffing dust'
  SCRAP_FROM_BARTER_BUYBACK: 4, //'scrap from barter/buy sell/buy back/ purity testing' 
  JOBWORK_METAL: 5, // 'jobwork metal'
  GMS_METAL: 6, // 'gms metal',
  NON_SERIALIZED_SKU : 7, // 'non-serialized SKU'
}

export const LOT_WEIGHT_LIMIT = 2050

export const METAL_LIMIT_FOR_FINANCIAL_YEAR ={
  EMPLOYEE_SILVER_LIMIT : 6000,
  EMPLOYEE_GOLD_LIMIT : 120,
  FRIENDS_AND_FAMILY_GOLD_LIMIT : 1200,
  FRIENDS_AND_FAMILY_SILVER_LIMIT : 12000
}

export const CHARGE_TYPES = {
  BUYBACK_TDS:'BUYBACK_TDS',
  BUYBACK_TCS:'BUYBACK_TCS',
  PURITY_TESTING_CHARGE:'PURITY_TESTING_CHARGE',
  REFINING_CHARGE:'REFINING_CHARGE',
  MELTING_CHARGE:'MELTING_CHARGE',
  PGM_CHARGE:'PGM_CHARGE',
  MAKING_CHARGE:'MAKING_CHARGE',
  DELIVERY_CHARGE:'DELIVERY_CHARGE',
}

export const TAX_PERCENTAGE = {
  SERVICE: 18,
  METAL: 3
}

export const IMPURE_METALS = ['Ir', 'Ru', 'Os', 'Pt', 'Pd']

export const CASH_TRANSACTION_LIMIT = 199999
export const PAN_LIMIT = 200000
export const PAN_CASH_LIMIT = 50000

export const PURITY_VERIFICATION_CHARGE_OPTIONS:TOption[] = [{label:'3000', value: 3000}, {label:'1000', value: 1000}, {label:'500', value: 500}]

export const TAX_TYPES = {
  GST:'GST',
  TDS: 'TDS',
  TCS: 'TCS'
}




export const MOP = ["CASH","CHEQUE","BANKAC","INTERNALADJUSTMENT","UPI" ,"RTGS"]

export const WEIGHT_MARGIN = 15

export const BANK_OPTIONS = [
  { label: 'SBI BANK', value: 'SBI Bank' }, 
  { label: 'HDFC BANK', value: 'HDFC Bank' }, 
  { label: 'HSBC BANK', value: 'HSBC Bank' }, 
  { label: 'ICICI BANK', value: 'ICICI Bank' }, 
  { label: 'BANK OF BARODA', value: 'Bank of Baroda' }, 
  { label: 'AXIS BANK', value: 'AXIS Bank' }, 
  { label: 'INDIAN BANK', value: 'INDIAN Bank' },
  { label: 'ALLAHABAD BANK', value: 'ALLAHABAD BANK' },
  { label: 'ANDHRA BANK', value: 'ANDHRA BANK'},
  { label: 'ANDHRA PRADESH GRAMEENA VIKAS BANK', value: 'ANDHRA PRADESH GRAMEENA VIKAS BANK'},
  { label: 'AU SMALL FINANCE BANK LTD.', value: 'AU SMALL FINANCE BANK LTD.'}, 
  { label: 'BANDHAN BANK', value: 'BANDHAN BANK'},
  { label: 'BANK OF INDIA', value: 'BANK OF INDIA'},
  { label: 'BANK OF MAHARASHTRA', value: 'BANK OF MAHARASHTRA'},
  { label: 'BARODA GUJARAT GRAMIN BANK', value: 'BARODA GUJARAT GRAMIN BANK'},
  { label: 'BHARAT CO-OPERATIVE BANK (MUMBAI) LTD', value: 'BHARAT CO-OPERATIVE BANK (MUMBAI) LTD'},
  { label: 'BHARAT OVERSEAS BANK ', value: 'BHARAT OVERSEAS BANK '},
  { label: 'BMC BANK', value: 'BMC BANK'},
  { label: 'BNCORPORATION BANK SHIMOGA', value: 'BNCORPORATION BANK SHIMOGA'},
  { label: 'CANARA BANK', value: 'CANARA BANK'},
  { label: 'CAPITAL SMALL FINANCE BANK LTD', value: 'CAPITAL SMALL FINANCE BANK LTD'},
  { label: 'CENTRAL BANK OF INDIA', value: 'CENTRAL BANK OF INDIA'},
  { label: 'CHENNAI CENTRAL CO-OPERATIVE BANK', value: 'CHENNAI CENTRAL CO-OPERATIVE BANK'},
  { label: 'CITI BANK', value: 'CITI BANK'},
  { label: 'CITIZEN CREDIT COOPRATIVE BANK', value: 'CITIZEN CREDIT COOPRATIVE BANK'},
  { label: 'CITY UNION BANK LTD.', value: 'CITY UNION BANK LTD.'},
  { label: 'CORPORATION BANK', value: 'CORPORATION BANK'},
  { label: 'COSMOS COOPERATIVE  BANK LTD.', value: 'COSMOS COOPERATIVE  BANK LTD.'},
  { label: 'CSB BANK LIMITED', value: 'CSB BANK LIMITED'},
  { label: 'DBS BANK', value: 'DBS BANK'},
  { label: 'DCB BANK LTD.', value: 'DCB BANK LTD.'},
  { label: 'DENA BANK', value: 'DENA BANK'},
  { label: 'DEUTSCHE BANK ', value: 'DEUTSCHE BANK '},
  { label: 'DHANLAXMI BANK LTD.', value: 'DHANLAXMI BANK LTD.'},
  { label: 'DNS BANK', value: 'DNS BANK'},
  { label: 'EQUATUS SMALL FINANCE BANK', value: 'EQUATUS SMALL FINANCE BANK'},
  { label: 'EQUITAS SMALL FINANCE BANK LTD', value: 'EQUITAS SMALL FINANCE BANK LTD'},
  { label: 'FEDERAL BANK', value: 'FEDERAL BANK'},
  { label: 'FEDERAL BANK LTD.', value: 'FEDERAL BANK LTD.'},
  { label: 'FINCARE BANK', value: 'FINCARE BANK'},
  { label: 'GUJARAT STATE CO-OPERATIVE BANK LTD.', value: 'GUJARAT STATE CO-OPERATIVE BANK LTD.'},
  { label: 'IDBI BANK LIMITED', value: 'IDBI BANK LIMITED'},
  { label: 'IDFC FIRST BANK LIMITED', value: 'IDFC FIRST BANK LIMITED'},
  { label: 'INDIAN BANK', value: 'INDIAN BANK'},
  { label: 'INDIAN OVERSEAS BANK', value: 'INDIAN OVERSEAS BANK'},
  { label: 'INDUSIND BANK LTD', value: 'INDUSIND BANK LTD'},
  { label: 'JAMMU & KASHMIR BANK LTD.', value: 'JAMMU & KASHMIR BANK LTD.'},
  { label: 'JANA SMALL FINANCE BANK LTD', value: 'JANA SMALL FINANCE BANK LTD'},
  { label: 'KARNATAKA BANK LTD.', value: 'KARNATAKA BANK LTD.'},
  { label: 'KARNATAKA GRAMIN BANK', value: 'KARNATAKA GRAMIN BANK'},
  { label: 'KARNATAKA VIKAS GRAMIN BANK', value: 'KARNATAKA VIKAS GRAMIN BANK'},
  { label: 'KARUR VYSYA BANK LTD.', value: 'KARUR VYSYA BANK LTD.'},
  { label: 'KERALA BANKING', value: 'KERALA BANKING'},
  { label: 'KERALA GRAMIN BANK', value: 'KERALA GRAMIN BANK'},
  { label: 'KOPAL BANK', value: 'KOPAL BANK'},
  { label: 'KOTAK MAHINDRA BANK', value: 'KOTAK MAHINDRA BANK'},
  { label: 'KOTAK MAHINDRA BANK LTD', value: 'KOTAK MAHINDRA BANK LTD'},
  { label: 'LAKSHMI VILAS BANK', value: 'LAKSHMI VILAS BANK'},
  { label: 'MAHARASHTRA GRAMIN BANK', value: 'MAHARASHTRA GRAMIN BANK'},
  { label: 'MP RAJYA SAHAKARI BANK MYDT', value: 'MP RAJYA SAHAKARI BANK MYDT'},
  { label: 'NAGPUR NAGRIK SAHKARI BANK LTD.', value: 'NAGPUR NAGRIK SAHKARI BANK LTD.'},
  { label: 'NAINITAL BANK LTD.', value: 'NAINITAL BANK LTD.'},
  { label: 'NEW INDIA CO-OPERATIVE BANK', value: 'NEW INDIA CO-OPERATIVE BANK'},
  { label: 'NKGSB CO- OF BANK LTD', value: 'NKGSB CO- OF BANK LTD'},
  { label: 'NUTAN NAGARIK SAHKARI BANK LTD', value: 'NUTAN NAGARIK SAHKARI BANK LTD'},
  { label: 'ORIENTAL BANK OF COMMERCE', value: 'ORIENTAL BANK OF COMMERCE'},
  { label: 'PANDHARPUR URBAN CO OP. BANK LTD', value: 'PANDHARPUR URBAN CO OP. BANK LTD'},
  { label: 'PARSIK JANATA SAHAKARI', value: 'PARSIK JANATA SAHAKARI'},
  { label: 'PUNJAB & SIND BANK', value: 'PUNJAB & SIND BANK'},
  { label: 'PUNJAB AND MAHARASHTRA BANK ', value: 'PUNJAB AND MAHARASHTRA BANK '},
  { label: 'PUNJAB GRAMIN BANK', value: 'PUNJAB GRAMIN BANK'},
  { label: 'PUNJAB NATIONAL BANK', value: 'PUNJAB NATIONAL BANK'},
  { label: 'RAJARAMBABPU  SAHAKARI BANK LTD', value: 'RAJARAMBABPU  SAHAKARI BANK LTD'},
  { label: 'RATNAKAR BANK LIMITED', value: 'RATNAKAR BANK LIMITED'},
  { label: 'RESERVE BANK OF INDIA', value: 'RESERVE BANK OF INDIA'},
  { label: 'SAPTAGIRI GRAMEENA BANK', value: 'SAPTAGIRI GRAMEENA BANK'},
  { label: 'SARASWAT BANK', value: 'SARASWAT BANK'},
  { label: 'SARASWAT COOPERATIVE BANK', value: 'SARASWAT COOPERATIVE BANK'},
  { label: 'SBM BANK INDIA', value: 'SBM BANK INDIA'},
  { label: 'SHAMRAO VITHAL CO-OP. BANK', value: 'SHAMRAO VITHAL CO-OP. BANK'},
  { label: 'SHAMRAO VITHAL COOPERATIVE BANK', value: 'SHAMRAO VITHAL COOPERATIVE BANK'},
  { label: 'SHIVALIK SMALL FINANCE BANK LTD', value: 'SHIVALIK SMALL FINANCE BANK LTD'},
  { label: 'SOUTH INDIAN BANK', value: 'SOUTH INDIAN BANK'},
  { label: 'SOUTH INDIAN BANK LTD.', value: 'SOUTH INDIAN BANK LTD.'},
  { label: 'STANDARD CHARTERED BANK', value: 'STANDARD CHARTERED BANK'},
  { label: 'STATE BANK OF BIKANER AND JAIPUR', value: 'STATE BANK OF BIKANER AND JAIPUR'},
  { label: 'STATE BANK OF HYDERABAD', value: 'STATE BANK OF HYDERABAD'},
  { label: 'STATE BANK OF MYSORE', value: 'STATE BANK OF MYSORE'},
  { label: 'STATE BANK OF PATIALA', value: 'STATE BANK OF PATIALA'},
  { label: 'STATE BANK OF TRAVANCORE', value: 'STATE BANK OF TRAVANCORE'},
  { label: 'SUMITOMO MITSUI BANKING CORPORATION BANK', value: 'SUMITOMO MITSUI BANKING CORPORATION BANK'},
  { label: 'SYNDICATE BANK', value: 'SYNDICATE BANK'},
  { label: 'TAMIL NADU GRAMA BANK', value: 'TAMIL NADU GRAMA BANK'},
  { label: 'TAMILNAD MERCANTILE BANK LTD.', value: 'TAMILNAD MERCANTILE BANK LTD.'},
  { label: 'TAMILNADU COOPERATIVE BANK', value: 'TAMILNADU COOPERATIVE BANK'},
  { label: 'TELANGANA GRAMEENA BANK', value: 'TELANGANA GRAMEENA BANK'},
  { label: 'TELANGANA STATE CO-OPERATIVE APEX BANK', value: 'TELANGANA STATE CO-OPERATIVE APEX BANK'},
  { label: 'THANE SAHAKARI JANATA BANK LTD', value: 'THANE SAHAKARI JANATA BANK LTD'},
  { label: 'THE AHMEDABAD DISTRICT CO OP BANK', value: 'THE AHMEDABAD DISTRICT CO OP BANK'},
  { label: 'THE ANDHRA PRADESH STATE COOPERATIVE BANK', value: 'THE ANDHRA PRADESH STATE COOPERATIVE BANK'},
  { label: 'THE COSMOS CO-OPERATIVE BANK LTD.', value: 'THE COSMOS CO-OPERATIVE BANK LTD.'},
  { label: 'THE KALUPUR COMMERCIAL CO OP BANK LTD', value: 'THE KALUPUR COMMERCIAL CO OP BANK LTD'},
  { label: 'THE KALYAN JANTA SAHAKARI BANK LTD.', value: 'THE KALYAN JANTA SAHAKARI BANK LTD.'},
  { label: 'THE KARNATAKA STATE CO-OPERATIVE APEX BANK LTD.', value: 'THE KARNATAKA STATE CO-OPERATIVE APEX BANK LTD.'},
  { label: 'THE KERALA STATE CO-OPERATIVE BANK LTD.', value: 'THE KERALA STATE CO-OPERATIVE BANK LTD.'},
  { label: 'THE NAVAL DOCKYARD CO OPERATIVE BANK LTD', value: 'THE NAVAL DOCKYARD CO OPERATIVE BANK LTD'},
  { label: 'THE RATNAKAR BANK LTD', value: 'THE RATNAKAR BANK LTD'},
  { label: 'THE SARASWAT CO-OPERATIVE BANK', value: 'THE SARASWAT CO-OPERATIVE BANK'},
  { label: 'THE TELANGANA STATE COOPERATIVE BANK LTD', value: 'THE TELANGANA STATE COOPERATIVE BANK LTD'},
  { label: 'THE UTTAR PRADESH CO-OPERATIVE BANK LTD.', value: 'THE UTTAR PRADESH CO-OPERATIVE BANK LTD.'},
  { label: 'THE VISAKHAPATNAM CO-OPERATIVE BANK LTD', value: 'THE VISAKHAPATNAM CO-OPERATIVE BANK LTD'},
  { label: 'THE WEST BENGAL STATE CO-OPERATIVE BANK LTD.', value: 'THE WEST BENGAL STATE CO-OPERATIVE BANK LTD.'},
  { label: 'THE ZOROASTRIAN CO-OP BANK ', value: 'THE ZOROASTRIAN CO-OP BANK '},
  { label: 'UCO BANK', value: 'UCO BANK'},
  { label: 'UJJIVAN SMALL FINANCE BANK LTD.', value: 'UJJIVAN SMALL FINANCE BANK LTD.'},
  { label: 'UNITED BANK OF INDIA', value: 'UNITED BANK OF INDIA'},
  { label: 'UTI BANK', value: 'UTI BANK'},
  { label: 'UTKARSH SMALL FINANCE BANK LTD.', value: 'UTKARSH SMALL FINANCE BANK LTD.'},
  { label: 'VIJAYA BANK', value: 'VIJAYA BANK'},
  { label: 'VIMA KAMGAR COOP. BANK LTD.', value: 'VIMA KAMGAR COOP. BANK LTD.'},
  { label: 'VITHAL CO-OP BANK LTD  ', value: 'VITHAL CO-OP BANK LTD  '},
  { label: 'YES BANK LTD.', value: 'YES BANK LTD.'},
  { label: 'INDIA POST PAYMENT BANK', value: 'INDIA POST PAYMENT BANK'},
  { label: 'CATHOLIC SYRIAN BANK LTD.', value: 'CATHOLIC SYRIAN BANK LTD.'},
  { label: 'MODEL CO-OP BANK LTD.', value: 'MODEL CO-OP BANK LTD.'},
  { label: 'ABHYUDAYA CO-OPERATIVE BANK LTD.', value: 'ABHYUDAYA CO-OPERATIVE BANK LTD.'},
  { label: 'SURYODAY SMALL FINANCE BANK', value: 'SURYODAY SMALL FINANCE BANK'},
  { label: 'Vasai Vikas Sahakari Bank Ltd', value: 'Vasai Vikas Sahakari Bank Ltd'},
  { label: 'Coastal Local Area Bank Ltd', value: 'Coastal Local Area Bank Ltd'}
]

export const USER_TYPES = {
  REGULAR: 'regular',
  FNF: 'F&F',
  EMPLOYEE: 'employee'
}

export const ADJUSTMENT_DIRECTION = {
  INBOUND: 1, //Addition
  OUTBOUND: 2 //Substraction
}

export const ADJUSTMENT_TYPE  = {
  CUT_BAR_ISSUE: 1,
  MANNUAL_ADJUSTMENT: 2
}

export const DOCUMENT_TYPES = {
  TAX_INVOICE: 'TAX_INVOICE',
  DELIVERY_CHALLAN: 'DELIVERY_CHALLAN',
  CERTIFICATE: 'CERTIFICATE',
  PURCHASE_RECIEPT: 'PURCHASE_RECIEPT',
  CONSENT_FORM: 'CONSENT_FORM',
  CREDIT_NOTE: 'CREDIT_NOTE', 
  ANNEXURE: 'ANNEXURE',
  SERVICE_TAX_INVOICE : 'SERVICE_TAX_INVOICE',
   ECOM_TAX_INVOICE :'ECOM_TAX_INVOICE'
}

export const CANCEL_REASONS = ['Due  to product rate change', 'Due to wrong location selection', 'Due to  product change or serial no', 'Due to payment mode  change','Due to customer name issue','Due to IRN issue','Due to serial number issue','Due to TCS  wrong charge','Due to address issue'
]

export const RGPStockModal = "RGPStockModal"